import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";

import ContractUtils from "services/contract/utils";
import MapActioner from "services/map/actioner";
import PedestrianStatisticsActioner from "services/pedestrianStatistics/actioner";

import HalfLayout from "components/HalfLayout";
import Map from "components/Map";
import PedestrianStatisticsLayout from "./components/PedestrianStatisticsLayout";
import MapComponent from "./components/MapComponent";

function PedestrianStatistics({
  currentFloor,
  currentFilters,
  currentFloorSelectedAreas,
  pedestrianStatistics,
  retrieveAllPedestrianStats,
  setCenterToDefault,
  setFilter,
}) {
  const initializeData = useCallback(() => {
    retrieveAllPedestrianStats();
  }, [retrieveAllPedestrianStats]);

  useEffect(() => {
    if (pedestrianStatistics?.map?.initialized) {
      initializeData();
    }
  }, [
    currentFloor,
    currentFilters?.areaType,
    pedestrianStatistics?.map?.initialized,
    pedestrianStatistics?.map?.selectedLayers,
    initializeData,
  ]);

  const handleRecenter = useCallback(
    (mapRef) => {
      if (!currentFloorSelectedAreas?.length) return null;

      const selectedAreasPolygons = currentFloorSelectedAreas.reduce(
        (polygons, area) => {
          return [...polygons, ...(area?.polygon || [])];
        },
        []
      );

      mapRef.fitBounds(selectedAreasPolygons, {
        padding: [50, 50],
      });
    },
    [currentFloorSelectedAreas]
  );

  const handleTimestampChange = useCallback(
    (timestamp) => {
      setFilter("timestamp", timestamp);
      initializeData();
    },
    [initializeData, setFilter]
  );

  return (
    <HalfLayout
      leftComponent={
        <PedestrianStatisticsLayout onTimestampChange={handleTimestampChange} />
      }
      rightComponent={
        <Map
          daysHoursSlider
          floorsButton
          getSliderMaxDaysAllowed={ContractUtils.getPedestrianMaxDaysAllowed}
          onRecenter={handleRecenter}
          selectedTimestamp={currentFilters?.timestamp}
          onTimestampChange={handleTimestampChange}
          mapComponent={<MapComponent onRecenter={setCenterToDefault} />}
          withCheckboxOptions={{
            displays: false,
            spaceLabels: false,
          }}
        />
      }
    />
  );
}

const mapStateToProps = (state) => ({
  currentFloor: state.Map?.config?.currentFloor,
  currentFilters: state.PedestrianStatistics.filters,
  currentFloorSelectedAreas:
    state.PedestrianStatistics?.map?.selectedLayers || [],
  pedestrianStatistics: state.PedestrianStatistics,
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, value) =>
    dispatch(PedestrianStatisticsActioner.setFilter(key, value)),
  retrieveAllPedestrianStats: () =>
    dispatch(PedestrianStatisticsActioner.retrieveAllStats()),
  setCenterToDefault: () => dispatch(MapActioner.setCenterToDefault()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedestrianStatistics);
